import React, { memo } from 'react';
/* Constants */
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
  LinkConfigEntity,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { GlobalSearchThumbnail } from 'site-modules/shared/components/inventory/global-search/global-search-thumbnail/global-search-thumbnail';
import { BaseGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/base-global-search-link';

export const CoreGlobalSearchLink = memo(props => (
  <BaseGlobalSearchLink linkThumbComponent={GlobalSearchThumbnail} {...props} />
));

CoreGlobalSearchLink.displayName = 'CoreGlobalSearchLink';

CoreGlobalSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
  linkConfig: LinkConfigEntity,
};

CoreGlobalSearchLink.defaultProps = {
  ...GlobalSearchLinkDefaultProps,
  linkConfig: {},
};
